import { render } from "./VPage.vue?vue&type=template&id=ac9d3f26&scoped=true"
import script from "./VPage.vue?vue&type=script&lang=js"
export * from "./VPage.vue?vue&type=script&lang=js"

import "./VPage.vue?vue&type=style&index=0&id=ac9d3f26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac9d3f26"]])

export default __exports__